<template>
    <v-container fluid>   
      <LeftMenu v-if="this.innerPage !='true'" />     
        <v-layout row wrap>  
          <v-flex xs1></v-flex>
          <v-flex xs11>
            <v-data-table
              :headers="headers"
              :items="offerListComputed"
              :items-per-page="1000"
              item-key="id"
              sort-by="offerNoText"
              :sort-desc=true
              class="elevation-1"
              hide-default-footer
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Offers</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <template >
                    <v-layout v-if="innerPage !='true'" row wrap>  
                      <v-flex xs2 class="pr-3">
                        <DatePicker picker-label="" :date-value="offersStartDate" @dateSelected="offersStartDate=$event" />
                      </v-flex>
                      <v-flex xs2 class="pr-3"> 
                        <DatePicker picker-label="" :date-value="offersEndDate" @dateSelected="offersEndDate=$event" />                  
                      </v-flex> 
                      <v-flex xs3><v-text-field v-model="search" label="Search " class="mx-4"></v-text-field></v-flex>
                      <v-flex xs1><v-btn color="primary" dark class="mb-2"  @click="searchOffers()">Search</v-btn></v-flex>
                      <v-flex xs1><v-btn color="primary" dark class="mb-2" @click="clearSearch()" >Clear</v-btn></v-flex>
                      <v-flex xs1></v-flex>
                      <v-flex xs1><v-btn color="primary" dark class="mb-2" @click="createNewOffer()" >New Offer</v-btn></v-flex>
                      <v-flex xs1></v-flex>
                    </v-layout>
                    <v-layout v-if="innerPage =='true'" row wrap>  
                      <v-flex xs8></v-flex>
                      <v-flex xs4><v-btn color="primary" dark class="mb-2" @click="createNewOffer()" >New Offer</v-btn></v-flex>
                    </v-layout>
                  </template>
                </v-toolbar>
              </template> 
              <template v-slot:body.append>                    
              </template>  
              <template v-slot:footer>       
                <Pagination v-if="innerPage !='true'" :record-count="recordCount" :default-page-size="defaultPageSize"
                       @pageNumberChanged="pageNumberChanged($event)" @pageSizeChanged="pageSizeChanged($event)" />             
              </template> 
              <template v-slot:item.goToDetails="{ item }">              
                <v-icon                  
                  @click="goToDetails(item)">
                  mdi-send
                </v-icon>                
              </template>     
              <template v-slot:item.status="{ item }">
                <v-chip :color="getStatusColor(item.status)" dark>{{ item.status }}</v-chip>
              </template>       
              <template v-slot:item.action="{ item }">          
                <v-icon                  
                  @click="generateWord(item)"
                >
                  mdi-file-word  
                </v-icon>   
                <v-icon                  
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>                                
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import getCurrentDate from '../helpers/getCurrentDate';
import getCurrentMonthStart from '../helpers/getCurrentMonthStart';
import getThisYearStart from '../helpers/getThisYearStart';
import LeftMenu from '../components/LeftMenu';
import DatePicker from '../components/DatePicker';
import Pagination from '../components/Pagination';
const API_URL = 'offers';
const PRICE_MODELS_API_URL = 'definitions/priceModels';
const CUSTOMERS_API_URL = 'definitions/customers';
const SALESMAN_API_URL = 'definitions/personnel/department/sales';
const SALES_API_URL  = 'sales';
export default {
    components:{
      LeftMenu,
      DatePicker,
      Pagination
    },
    props: {
      innerPage: String,
      currentCustomer : {}
    },
    data () {
    return {
      search: '',
      offersStartDate: '',
      offersEndDate: '',
      offers: [
        {     
          customerName: '',
          offerDate: '',
          status: '',  
        },               
      ],
      defaultPageSize : 25,
      recordCount : 0,
    }
  },
  computed: {
    headers () {
      return [
        { text: '',align: 'left',sortable: false,value: 'goToDetails'},
        { text: 'Offer No',  value: 'offerNoText'  },  
        {
          text: 'Customer',align: 'left',sortable: true,
          value: 'customer.customerName',
        },
        { text: 'Offer Date',  value: 'offerDate'  },        
        { text: 'Validity Days',  value: 'validityDays'  }, 
        { text: 'Currency', value: 'currency.code' },
        { text: 'Personnel',  value: 'salePersonnel.name'  },  
        { text: 'Status',  value: 'status'  },               
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },
    isInnerPage(){
      return this.innerPage =='true';
    },
    offerListComputed(){
      return this.offers.map((item) => {   
        if(item.versionNo>0){
          item.offerNoText = item.offerNo+' - '+item.versionNo;
        }else{
          item.offerNoText = item.offerNo
        }         

        if(item.status=="OPEN"){
          let validityDays = item.validityDays;
          if(!item.validityDays)   {
            validityDays = 0;
          }   
          let offerExpireDate = new Date(item.offerDate);
          offerExpireDate.setDate(offerExpireDate.getDate()+validityDays);

          var today = new Date();
          if(today > offerExpireDate) {
            item.status = "EXPIRED";
          }
        }
        return item;    
      })
    },
    formTitle () {
      return  'New Offer';
    },
  },
  created() {    
    this.fillIntervalDates();
    //this.getOffersByInterval(1,this.defaultPageSize);    
  },
  watch: {
    offersStartDate (val){
      this.offersStartDate = val;
      if(val && this.offersEndDate){        
        this.getOffersByInterval(1,this.defaultPageSize);   
      }
    },
    offersEndDate(val){
      this.offersEndDate = val;
      if(val && this.offersStartDate){      
        this.getOffersByInterval(1,this.defaultPageSize);   
      }
    },
  },
  methods: {
    goToDetails(item){
      //this.$router.push('/offers/'+item.id);
      const routeData = this.$router.resolve('/offers/'+item.id);
      window.open(routeData.href, '_blank');
    },
    async fillIntervalDates(){
      await this.setEndDate();
      this.offersStartDate = getThisYearStart();
    },
    async setEndDate(){
      this.offersEndDate = getCurrentDate();
    },
    createNewOffer(){
      this.$router.push('/offers/new');
    },
    clearSearch(){
      this.search = '';
      this.getOffersByInterval(1, this.defaultPageSize);
    },
    getStatusColor (status) {
      if(status == '') return ''
      else if (status =='OPEN') return 'blue'
      else if (status =='SOLD') return 'green'
      else if (status =='EXPIRED') return 'orange'
      else return ''
    },
    deleteItem (item) {
      const index = this.offers.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.offers.splice(index, 1);
        this.deleteOffer(item);
      } 
    },
    generatePdf(item) {          
      this.$axios({
        url: this.$apiurl + API_URL+'/'+item.id+'/generatePdf',
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Offer_'+item.offerNo+'.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
      })
    },
    generateWord(item) {          
      this.$axios({
        url: this.$apiurl + API_URL+'/'+item.id+'/generateWord',
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Offer_'+item.offerNo+'.docx');
        document.body.appendChild(fileLink);
        fileLink.click();
      })
    },
    deleteOffer(item){
      this.$axios.delete(this.$apiurl + API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    pageSizeChanged(pageSize){
      this.defaultPageSize = pageSize;
      this.getOffersByInterval(1, pageSize);
    },
    pageNumberChanged(pageNumber){
      this.getOffersByInterval(pageNumber, this.defaultPageSize);
    },
    searchOffers(){
      if(!this.search || this.search.length < 3){
        alert('Type at least 3 characters to search!');
        return;
      }
      var url = this.$apiurl + API_URL +"/search/"+this.search;
      this.$axios.get(url)
        .then(response => {
            this.offers = response.data;
            this.recordCount = response.data.length;
        }) 
        .catch(error => {
            console.log(error);
        });
    },
    getOffers(pageNumber, pageSize){  
      var url = this.$apiurl + API_URL; 
      if(this.innerPage){
        url += "/customer/"+this.$route.params.id;
        this.$axios.get(url)
          .then(response => {
              this.offers = response.data;
          }) 
          .catch(error => {
              console.log(error);
          });  
      }else{
        url += "/paginated/" + pageSize + "/" + pageNumber;
        this.$axios.get(url)
          .then(response => {
              this.offers = response.data.offerList;
              this.recordCount = response.data.allOfferCount;
          }) 
          .catch(error => {
              console.log(error);
          });  
      }                      
    },
    getOffersByInterval( pageNumber, pageSize ){
      var url = this.$apiurl + API_URL; 
      if(this.innerPage){
        url += "/customer/"+this.$route.params.id;
        this.$axios.get(url)
          .then(response => {
              this.offers = response.data;
          }) 
          .catch(error => {
              console.log(error);
          });  
      }else{
        url += "/paginated/" + pageSize + "/" + pageNumber;
        this.$axios.get(url, { 
            params: {
              startDate: this.offersStartDate,
              endDate: this.offersEndDate
            }                                               
          })
          .then(response => {
              this.offers = response.data.offerList;
              this.recordCount = response.data.allOfferCount;
          }) 
          .catch(error => {
              console.log(error);
          });  
      }
    },
  },
}
</script>
